import React from 'react';

const MyPortfolio = () => {
    return (
        <div>
            <h1 className="text-center text-accent text-5xl font-bold my-5">Welcome To My Portfolio</h1>
        </div>
    );
};

export default MyPortfolio;